import { z } from 'zod/v4';

export const metricLogSchema = z.object({
  dailySummary: z
    .object({
      assetID: z.string().min(1),
      jsonTimestamp: z.string().min(1),
    })
    .passthrough(),
});

export type MetricLog = z.infer<typeof metricLogSchema>;
